<template>
  <div class="loader">
    <div class="loading mask" v-show="channels.foreground > 0">
      <div class="sk-wave">
        <div class="sk-rect sk-rect1"></div>
        <div class="sk-rect sk-rect2"></div>
        <div class="sk-rect sk-rect3"></div>
        <div class="sk-rect sk-rect4"></div>
        <div class="sk-rect sk-rect5"></div>
      </div>
    </div>

    <div class="loading indicator" v-show="channels.background > 0">
      <div class="sk-wave">
        <div class="sk-rect sk-rect1"></div>
        <div class="sk-rect sk-rect2"></div>
        <div class="sk-rect sk-rect3"></div>
        <div class="sk-rect sk-rect4"></div>
        <div class="sk-rect sk-rect5"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Emitter } from 'src/utilities';

export default {
  data() {
    return {
      channels: {
        foreground: 0,
        background: 0,
      },
    };
  },

  compiled() {
    Emitter.on('request:start', options => this.channels[options.channel]++);
    Emitter.on('request:end', options => this.channels[options.channel]--);
  },
};
</script>



// WEBPACK FOOTER //
// Loader.vue?10bcf333